<div class="mt-2" *ngIf="form; else loadingComponent">
  <h4 class="mb-0 mt-2">{{ formData?.title }}</h4>

  <app-form-submission
    *ngIf="form"
    [formData]="form"
    [submission]="submission"
    [readonly]="readonly"
    [currentStep]="currentStep"
    [isSubmitting]="loadingStates.submission || isSubmitting"
    (onPrev)="goToPreviousStep($event)"
    (onCancel)="goBack($event)"
    (onSubmit)="onFormSubmit($event)"
  ></app-form-submission>
</div>

<ng-template #loadingComponent>
  <div class="card card-fit mt-2">
    <div class="card-body pb-1">
      <div
        class="flex flex-1 gap-2 p-1 flex-column justify-content-center align-items-center"
      >
        <span class="spinner-border text-primary spinner-border-lg mr-1"></span>
        <span>Carregando</span>
      </div>
    </div>
  </div>
</ng-template>
